import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Formula } from "models/product.types";
import { getCartFormula, setCartFormula, clearCartFormula } from "utils/formulaColors";
import { getFlowClass, shouldApplyFormulaFlow } from "utils/formulaColors";

type FormulaFlowContextType = {
    formula: Formula | null | undefined;
    flowClass: string;
    isActive: boolean;
    setFormula: (f: Formula | null | undefined) => void;
    clearFormula: () => void;
  };
  
  export const FormulaFlowContext = createContext<FormulaFlowContextType | null>(null);
  
  export const FormulaFlowProvider = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation<{ formula?: Formula }>();
    // const [pathname, setPathname] = useState(location.pathname);
    
    const [formula, setFormula] = useState<Formula | null | undefined>(location.state?.formula);
  
    useEffect(() => {
      setFormula(location.state?.formula);
    }, [location.state?.formula]);

    const isActive = useMemo(
      () => shouldApplyFormulaFlow(window.location.pathname, formula),
      [formula]
    );
  
    const flowClass = useMemo(
      () => (isActive ? `formula-flow ${getFlowClass(formula)}` : ""),
      [isActive, formula]
    );
  
    const setFormulaFlow = useCallback((f: Formula | null | undefined) => {
      setFormula(f);
      if (f) {
        setCartFormula(f);
      } else {
        clearCartFormula();
      }
    }, [setFormula]);
  
    const clearFormula = useCallback(() => {
      setFormula(undefined);
      clearCartFormula();
    }, [setFormula]);
  
    return (
      <FormulaFlowContext.Provider
        value={{
          formula,
          flowClass,
          isActive,
          setFormula: setFormulaFlow,
          clearFormula,
        }}
      >
        {children}
      </FormulaFlowContext.Provider>
    );
  };